import 'gridstrap/svg-symbols/face-smile.svg?sprite';
import 'gridstrap/svg-symbols/face-frown.svg?sprite';
import './outline-button.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSOutlineButton } from './outline-button';

components.register({
	selector: '.gs-OutlineButton',
	controller: GSOutlineButton
});
